var AdaptiveImage = require( "../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "d43173a87f485a16276a81caaa32619b.png",
    width: 359,
    height: 86
});